var map = {
	"./acad.png": 4649,
	"./ararat.png": 1559,
	"./bee_taxi.png": 8755,
	"./diamond.png": 5069,
	"./diamond_line.png": 614,
	"./hadyati.png": 7539,
	"./halal.png": 170,
	"./halal_acad.png": 6782,
	"./khalilak.png": 5905,
	"./new_hiba.png": 4141,
	"./unicorn.png": 7399,
	"./اسالني.png": 2124,
	"./يد التضامن.png": 5769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3576;